<template>
  <div id="printerGroupEdit">

    <PageTitle :title="groupId ? $to(group.name) : $t('printer_groups.new')"></PageTitle>

    <PageContainer v-if="group">
      <div class="title">{{$t('printer_groups.title_2')}}</div>
      <label class="description">{{$t('printer_groups.description')}}</label>
      <br>
      <div class="subtitle">{{$t('printer_groups.general_information')}}</div>
      <label class="description">{{$t('printer_groups.general_description')}}</label>
      <br>
      <div class="columns">
        <div class="column">
          <div class="group">
            <LocalizedInput :title="$t('printer_groups.name')" :translate="group.name"></LocalizedInput>
          </div>
        </div>
        <div class="column">&nbsp;</div>
      </div>

      <div class="separator"></div>

      <div class="subtitle">{{$t('printer_groups.products_title')}}</div>
      <label class="description">{{$t('printer_groups.products_description')}}</label>
      <br>

      <div class="group">
        <ListMultiSelect
            :bank="items"
            :selected="group.items"
            showSelectAll showUnselectAll
            :bank-title="$t('printer_groups.inventory')"
            :selected-title="$t('printer_groups.linked_products')"
        />
      </div>

    </PageContainer>

    <PageFooter :backAction="{text: $t('printer_groups.back'), action: back}"
                :secondaryActions="[{text: $t('save_and_quit'), action: saveAndQuit}]"
                :mainAction="{text: $t('save'), action: save}"></PageFooter>

  </div>
</template>

<script>
  import {Core} from "@/core/Core";
  import PageTitle from "@/components/PageTitle";
  import PageFooter from "@/components/PageFooter";
  import PageContainer from "@/components/PageContainer";
  import LocalizedInput from "@/components/tools/LocalizedInput";
  import ListMultiSelect from "@/components/tools/ListMultiSelect";

  export default {
    name: "PrinterGroupEdit",

    components: { PageTitle, PageContainer, PageFooter, LocalizedInput, ListMultiSelect },

    data() {
      return {
        inventory: null,
        company: null,
        items: [],
        categories: [],
        group: {
          items: [],
          name: { fr: "", en: "" }
        }
      }
    },

    computed: {
      groupId() {
        return this.$route.query.id;
      }
    },

    async mounted() {
      showSpinner();
      this.$store.state.pageTitleTranslationKey = "printer_groups.title";
      this.$store.state.pageIcon = "/icon/printer.svg";
      await this.loadInventory();
      hideSpinner();
    },

    methods: {
      async loadInventory() {
        this.inventory = await this.$store.getters.getContextInventory;
        this.company = await this.$store.getters.getContextCompany;
        try {
          let [categories, items, group] = await Promise.all([
            Core.request("GET", `/api/inventory/${this.inventory.id}/categories`),
            Core.request("GET", `/api/inventory/${this.inventory.id}/items`),
            this.groupId ? Core.request("GET", `/api/printer_groups/${this.groupId}?company=${this.company.id}`) : undefined
          ]);
          for (let item of items) {
            item.categories = item.categories.map(i => {
              let category = categories.find(c => c.id === i);
              return category ? this.$to(category.name) : "";
            });
          }
          this.items = items.map(i => ({
            name: i.categories.join(", ") + (i.categories.length > 0 ? " - " : "") + this.$to(i.name),
            id: i.id
          }));
          if (this.groupId && group) {
            group.items = group.items.map(i => this.items.find(o => o.id === i)).filter(i => !!i);
            this.group = group;
          }
        } catch (e) {
          console.log(e);
        }
      },
      back() {
        this.$router.push(this.$router.buildContext("/printer-groups"));
      },
      async save() {
        showSpinner();
        let data = {
          id: this.group.id || undefined,
          name: this.group.name,
          items: this.group.items.map(i => i.id)
        };
        let response = this.groupId ?
            await Core.request('PUT', `/api/printer_groups/${this.groupId}?company=${this.company.id}`, data) :
            await Core.request('POST', `/api/printer_groups?company=${this.company.id}`, data);
        hideSpinner();
        if (response) {
          toast(this.$t("printer_groups.save_success"), "success");
          this.group.id = response.id;
          this.$router.push(this.$router.buildContext("/printer-group/edit", {id: response.id}));
        } else {
          toast(this.$t("printer_groups.save_error"), "error");
        }
      },
      async saveAndQuit() {
        await this.save();
        this.back();
      }
    }
  }
</script>

<style lang="scss" scoped>
  .title {
    font-size: 16px;
    font-weight: bold;
    color: #1A1A1A;
  }
  .separator {
    border: 1px dashed #e6e6e6;
    margin-top: 20px;
    margin-bottom: 15px;
    width: 100%;
    height: 1px;
  }
</style>